import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { leaveService } from "../../../services/extensions";
import { useSelector } from "react-redux";
import moment from "moment";
import NewAbsenceRequest from "../NewAbsenceRequest";
import { Dialog } from "primereact/dialog";
import { Status, LeaveStatus, LeaveStatusCode } from '../../../common/util/constants';


const ResourceCalendar = () => {
    const { user } = useSelector(state => state.user);
    const localizer = momentLocalizer(moment);
    const [eventsData, setEventsData] = useState([]);
    const [userLeaves, setUserLeaves] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [newEvent, setNewEvent] = useState({ start: null, end: null });

    useEffect(() => {
        getLeaves();
    }, []);

    const reload = () => {
        getLeaves();
        setShowDialog(false);
    }

    const getLeaves = () => {
        leaveService.getAllLeaves(user?.id).then(resp => {
            const data = resp.data.data;
            const leaveData = data.map(e => {
                const sd = new Date(e.startDate);
                const ed = new Date(e.endDate);
                const start = e.leaveType === 'FD' ? new Date(sd.getFullYear(), sd.getMonth(), sd.getDate(), 0, 0, 0) : sd;
                const end = e.leaveType === 'FD' ? new Date(ed.getFullYear(), ed.getMonth(), ed.getDate(), 23, 59, 59) : ed;
                return {
                    id: e.id,
                    title: LeaveStatusCode[e.status] + " - " + e.absenceCode + " - " + e.reasonOfLeave,
                    start: start,
                    end: end,
                    absCode: e.absenceCode,
                    type: e.leaveType,
                    reason: e.reasonOfLeave

                }
            });
            setEventsData(leaveData);
        });
    };

    const getAllLeaves = async () => {
        try {
            const resp = await leaveService.getAllMonthLeaves();
            setUserLeaves(resp.data.data);
            return resp.data.data;
        } catch (error) {
            console.error("Error fetching leaves:", error); // Added error logging
            return [];
        }
    };


    const handleSelect = ({ start, end }) => {
        // const newEndData = moment(end).subtract(1, 'day').toDate();
        const newEndDate = moment(end).subtract(1, 'day').endOf('day').toDate();
        setNewEvent({ start, end: newEndDate });
        getAllLeaves();
        setShowDialog(true);
    };

    const renderNewLeave = () => {
        return (<>
            <Dialog className="custom_popup" header="New Absence Request" visible={showDialog} onHide={() => setShowDialog(false)} style={{ width: '70vw' }}>
                <NewAbsenceRequest leaves={userLeaves.filter(x => x.status === LeaveStatus.DRAFT && x.status !== Status.ARCHIVE) || []}
                    reload={reload} dialog={true} start={newEvent.start} end={newEvent.end} />
            </Dialog>
        </>)
    }
    return (
        <div>
            {renderNewLeave()}
            <Calendar
                views={["day", "work_week", "month"]}
                selectable
                localizer={localizer}
                defaultDate={new Date()}
                defaultView="month"
                events={eventsData}
                style={{ height: "calc(100vh - 230px)" }}
                onSelectEvent={(event) => console.log(event.title)}
                onSelectSlot={handleSelect}
            />
        </div>
    )
}

export default ResourceCalendar